import React, { useState, useRef, useEffect } from 'react'

import './MultiSelect.scss'

import { Activity, ChevronUp, ChevronDown } from "react-feather";

function MultiSelect({ options, value=[], onChange, data }) {
  const [open, setOpen] = useState(false);

  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleOption = (id) => {
    let newSelected;

    if (value.includes(id)) {
      newSelected = value.filter((item) => item !== id);
    } else {
      newSelected = [...value, id];
    }

    if (onChange) {
      onChange(newSelected);
    }
  };

  const selectedNames = options
    .filter((item) => value.includes(item.id))
    .map((item) => item.name);

  const isWidgetActive = (id) => {
    const widget = data?.find((item) => item.id === id);

    if (!widget) {
      return false;
    }

    const visits = Number(widget.total?.visits) || 0;
    const views = Number(widget.total?.views) || 0;
    const clicks = Number(widget.total?.clicks) || 0;

    return visits > 0 || views > 0 || clicks > 0;
  };


  return (
    <div className="multiselect" ref={containerRef}>
      <button
        type="button"
        className="multiselect-button"
        onClick={() => setOpen(!open)}
      >
        <span className="multiselect-button__text">
          {selectedNames.length > 0
            ? selectedNames.join(", ")
            : "Выберите виджеты"}
        </span>

        <span className="multiselect-button__chevron">
          {open ? (
            <ChevronUp size={16} />
          ) : (
            <ChevronDown size={16} />
          )}
        </span>
      </button>

      {open && (
        <div className="multiselect-dropdown">
          {options.map((item) => (
            <label
              key={item.id}
              className="multiselect-option"
            >
              <input
                type="checkbox"
                checked={value.includes(item.id)}
                onChange={() => toggleOption(item.id)}
              />

              <span className="multiselect-option__name">{item.name}</span>

              {/* показатель активности виджета */}
              {isWidgetActive(item.id) && (
                <span className="multiselect-option__active-dot" title="Активность виджета">
                  <Activity color="#222" size={12} />
                </span>
              )}

            </label>
          ))}
        </div>
      )}
    </div>
  );
}

export default MultiSelect;